export default __webpack_public_path__ + "static/media/SAS0310.34I-41716_-25010_0.4b8f1128.jpg";